import styled from "styled-components";

export const WalletVerificationPage = styled.iframe.attrs({
  src: "https://form.typeform.com/to/xgYhrmHx",
})`
  border: none;
  width: 100%;
  height: 100%;
`;
